import { type Dispatch, type SetStateAction, type ChangeEvent } from 'react'

import { type IAdditionalInfo2Children } from '@/app/types/doctorsType'
import { type EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

import { type TIconTypes, type IICons, type TItemType, type IAdditionalInfo2Editable } from '../../../helper'

import style from './ContentItem.module.scss'

interface IProps extends IAdditionalInfo2Children {
    setData: Dispatch<SetStateAction<IAdditionalInfo2Editable[]>>
    itemType: TItemType
    iconsMapper: Record<TIconTypes, EIcons>
    onRemoveChild: (itemId: string) => void
    parentId: string
}

export const ContentItem = (props: IProps) => {
    const { id, parentId, title, itemType, iconsMapper, onRemoveChild, setData } = props

    const actions: IICons[] = [
        {
            type: 'remove',
            callback: () => onRemoveChild(id),
            disbled: true,
            belongTo: 'create'
        },
        {
            type: 'remove',
            callback: () => onRemoveChild(id),
            disbled: true,
            belongTo: 'update'
        }
    ]

    const onChangeChildTitle = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.currentTarget
        setData((prev) =>
            prev.map((section) =>
                section.id === parentId
                    ? {
                          ...section,
                          items: section.items.map((item) => (item.id === id ? { ...item, title: value } : item))
                      }
                    : section
            )
        )
    }

    return (
        <div className={style.container}>
            {itemType === 'read' ? (
                <span>{title}</span>
            ) : (
                <div className={style.fields}>
                    <input value={title} onChange={onChangeChildTitle} placeholder='Заполните содержание' />
                    <div className={style.icons}>
                        {actions
                            .filter(({ belongTo }) => belongTo === itemType)
                            .map((action, idx) => (
                                <div key={idx} className={style.icon} onClick={action.callback}>
                                    <Icon iconName={iconsMapper[action.type]} color={action.iconColor} />
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </div>
    )
}
